import { parseQnaCategoryGroup } from '@/parsers/qna';

import { useGetQnaCategoryGroupQuery } from './mobile/qna.gql.impl';

const useGetQnaCategoryGroup = () => {
  const { data: categoryGroup } = useGetQnaCategoryGroupQuery(
    {},
    {
      select: parseQnaCategoryGroup,
    },
  );

  return { categoryGroup };
};

export default useGetQnaCategoryGroup;
